<template>
  <div>
    <v-row v-for="day in week" :key="day">
      <v-col cols="12" md="6">
        <!-- Open At -->
        <v-menu v-model="timepickerOpen[day]"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <gg-text-field v-model="schedule[day].open"
                          outlined
                          :label="`${day} Open Time`"
                          readonly
                          v-bind="attrs"
                          v-on="on"></gg-text-field>
          </template>
          <v-time-picker v-if="timepickerOpen[day]"
                         :value="convertTime(schedule[day].open)"
                         @change="setTime($event, day, 'open')"
                         @update:period="updatePeriod($event, day, 'open')"
                         ampm-in-title
                         full-width></v-time-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="6">
        <!-- Closed -->
        <v-menu v-model="timepickerClosed[day]"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <gg-text-field v-model="schedule[day].closed"
                          outlined
                          :label="`${day} Closed Time`"
                          readonly
                          v-bind="attrs"
                          v-on="on"></gg-text-field>
          </template>
          <v-time-picker v-if="timepickerClosed[day]"
                         :value="convertTime(schedule[day].closed)"
                         @change="setTime($event, day, 'closed')"
                         @update:period="updatePeriod($event, day, 'closed')"
                         ampm-in-title
                         full-width></v-time-picker>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'WorkSchedule',
  data () {
    return {
      weekStartsOn: 'Sunday',
      weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      timepickerOpen: {
        'Monday': false,
        'Tuesday': false,
        'Wednesday': false,
        'Thursday': false,
        'Friday': false,
        'Saturday': false,
        'Sunday': false
      },
      timepickerClosed: {
        'Monday': false,
        'Tuesday': false,
        'Wednesday': false,
        'Thursday': false,
        'Friday': false,
        'Saturday': false,
        'Sunday': false
      },
      schedule: {
        'Monday': { open: null, closed: null },
        'Tuesday': { open: null, closed: null },
        'Wednesday': { open: null, closed: null },
        'Thursday': { open: null, closed: null },
        'Friday': { open: null, closed: null },
        'Saturday': { open: null, closed: null },
        'Sunday': { open: null, closed: null }
      }
    }
  },
  computed: {
    week () {
      const firstDay = this.weekDays.indexOf(this.weekStartsOn)
      const first = this.weekDays.slice(firstDay, this.weekDays.length)
      return [
        ...first,
        ...this.weekDays.filter(day => first.indexOf(day) === -1)
      ]
    }
  },
  methods: {
    ...mapMutations({
      setHours: 'wizard_model/SET_SS_HOURS',
    }),
    setTime (time24h, day, openClosed) {
      const hoursMinutes = time24h.split(':')
      const ampm = hoursMinutes[0] >= 12 ? 'PM' : 'AM'
      let hour = hoursMinutes[0] % 12
      hour = hour || 12
      const time = `${hour}:${hoursMinutes[1]} ${ampm}`
      this.schedule[day][openClosed] = time
      this.setHours({ time, openClosed, day })
    },
    convertTime (time12h) {
      if (!time12h) return time12h
      const [time, modifier] = time12h.split(' ')
      let [hours, minutes] = time.split(':')
      if (hours === '12') {
        hours = '00'
      }
      if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12
      }
      return `${hours}:${minutes}`
    },
    updatePeriod (ampm, day, openClosed) {
      if (!this.schedule[day][openClosed]) return
      const hours = this.schedule[day][openClosed].split(' ')[0]
      const time = `${hours} ${ampm.toUpperCase()}`
      this.schedule[day][openClosed] = time
      this.setHours({ time, openClosed, day })
    },
  },
}
</script>
